import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from 'apollo-react/components/Typography';

const Home = () => {
  const [t] = useTranslation();

  return (
    <div className="content">
      <Typography variant="subheadline" gutterBottom>
        {/* {t('homepage')} */}
      </Typography>
    </div>
  );
};

export default Home;